import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import React, { FC } from 'react';
import './TimetableWidgetSkeleton.scss';

export const TimetableWidgetSkeleton: FC = () => {
  return (
    <div className="timetableWidgetSkeleton flex flex-col gap-2">
      {[1, 2].map(index => (
        <Skeleton key={index} className="skeletonEvent">
          <div className="flex flex-col gap-1">
            <SkeletonItem size={12} className="skeletonPeriod" />
            <SkeletonItem size={16} className="skeletonTitle" />
            <SkeletonItem size={12} className="skeletonClass" />
            <SkeletonItem size={12} className="skeletonTeacher" />
          </div>
        </Skeleton>
      ))}
    </div>
  );
};
